import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
import logo from "../../../../src/assets/admin/img/logos/logo-1.svg";
import shortLogo from "../../../../src/assets/admin/img/logos/netball-logo1.png";
import { useTranslation } from "react-i18next";
import { hasP } from "../../../utils/commonfunction";
import * as globalsettingService from "../services/globalsetting.services";

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();
  const [isDev, setIsDev] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryDev = searchParams.get("dev");
    if (queryDev === "true") {
      localStorage.setItem("dev", "true");
    } else if (queryDev === "false") {
      localStorage.setItem("dev", "false");
    }

    const envDev = process.env.REACT_APP_DEV === "true";
    const localDev = localStorage.getItem("dev") === "true";

    globalsettingService.Details().then((res) => {
      const data = res?.data || res;
      const settingDev = data?.dev === true || data?.dev === "true" || data?.is_dev === true || data?.dev_mode === true;
      setIsDev(settingDev || localDev || envDev);
    }).catch((err) => {
      console.error("Error fetching global settings in sidebar", err);
      setIsDev(localDev || envDev);
    });
  }, []);

//   const toggleDropdown = (e) => {
//     e.preventDefault();
//     const dropDown = e.currentTarget.parentElement;
//     if (dropDown.classList.contains("show")) {
//       dropDown.classList.remove("show");
//     } else {
//       dropDown.classList.add("show");
//     }
//   };

  const toggleDropdown = (e) => {
    e.preventDefault();
    const clickedItem = e.currentTarget.parentElement;
    const isAlreadyOpen = clickedItem.classList.contains("show");

    document.querySelectorAll(".nav-item.show").forEach((item) => {
      item.classList.remove("show");
    });
             
    if (!isAlreadyOpen) {
      clickedItem.classList.add("show");
    }
  };

  const hoverSidebar = (e) => {
    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").addClass("main-sidebar-open");
    } else {
      $("body").removeClass("main-sidebar-open");
    }
  };

  const removeHoverSidebar = (e) => {
    $("body").removeClass("main-sidebar-open");
  };

  return (
    <div
      className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y"
      id="app_sidebar"
      onMouseEnter={hoverSidebar}
      onMouseLeave={removeHoverSidebar}
    >
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard">
          <img
            src={shortLogo}
            className="header-brand-img icon-logo"
            alt="logo"
            style={{ height: "35px", width: "35px" }}
            id="logo_short"
          />
          <img
            src={logo}
            className="header-brand-img desktop-logo rounded"
            style={{ height: "auto", width: "9rem" }}
            alt="logo"
            id="logo_full"
          />
        </a>
      </div>

      <div className="main-sidebar-body">
        <ul className="nav">

          {/* Dashboard */}
          <li
            className={
              "nav-item" +
              (loc.pathname === "/admin/dashboard" ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/dashboard">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-home sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_dashboard")}</span>
            </Link>
          </li>

          {/* CMS Section */}
          {(
            hasP("cms-list", true) ||
            hasP("email-templates-list", true) ||
            hasP("faq-list", true) ||
            hasP("global-settings-view", true)
            // hasP("global-settings", true)
          ) ? (
            <li
              className={
                "nav-item " +
                (loc.pathname.includes("/cms") ? "show active" : "")
              }
            >
              <a
                className="nav-link with-sub submenu"
                onClick={toggleDropdown}
                href="/"
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-cogs sidemenu-icon"></i>
                <span className="sidemenu-label">{t("sidebar_link_cms")}</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              <ul className="nav-sub">

                {hasP("cms-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/cms/pages") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/cms/pages/list/1`}>
                      {t("sidebar_link_pages")}
                    </Link>
                  </li>
                ) : null}

                {hasP("consent-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/cms/consent") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/cms/consent/list/1`}>
                      User Consents
                    </Link>
                  </li>
                ) : null}

                {hasP("cms-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/cms/website") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/cms/website/list/1`}>
                      Website
                    </Link>
                  </li>
                ) : null}

                {hasP("agreements-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/cms/agreements") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/cms/agreements/list/1`}>
                      Agreement Management
                    </Link>
                  </li>
                ) : null}

                {hasP("email-templates-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/cms/default-email-template") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/cms/default-email-template/list/1`}>
                      {t("sidebar_link_email_template")}
                    </Link>
                  </li>
                ) : null}

                {hasP("global-settings-view") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/cms/settings") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/cms/settings`}>
                      {t("sidebar_link_global_settings")}
                    </Link>
                  </li>
                ) : null}

                {hasP("faq-list", true) ? (
                  <li
                    className={
                      "nav-sub-item " +
                      (loc.pathname.includes("/cms/faq-management") ? "show active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/cms/faq-management/faq/list/1`}>
                      {t("sidebar_link_faq")}
                    </Link>
                  </li>
                ) : null}
              </ul>
            </li>
          ) : null}

          {/* User Management */}
          {(
            hasP("club-admin-list", true) ||
            hasP("players-list", true) ||
            hasP("basic-user", true) ||
            hasP("parent-list", true) ||
            hasP("sub-admin-list", true)
          ) ? (
            <li
              className={
                "nav-item " +
                (loc.pathname.includes("/user-management") ? "show active" : "")
              }
            >
              <a
                className="nav-link with-sub submenu"
                onClick={toggleDropdown}
                href="/"
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-users sidemenu-icon"></i>
                <span className="sidemenu-label">User</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>

              <ul className="nav-sub">
                {hasP("sub-admin-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/user-management/sub-admins") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/user-management/sub-admins/list/1`}>
                      Sub Admin
                    </Link>
                  </li>
                ) : null}
                {hasP("club-admin-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/user-management/club-admins") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/user-management/club-admins/list/1`}>
                      Club Admin
                    </Link>
                  </li>
                ) : null}
                    {hasP("team-manager-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/user-management/team-managers") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/user-management/team-managers/list/1`}>
                      Team Managers
                    </Link>
                  </li>
                ) : null}
                {hasP("parent-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/user-management/parent-admins") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/user-management/parent-admins/list/1`}>
                      Parent
                    </Link>
                  </li>
                ) : null}

                {hasP("players-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/user-management/players") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/user-management/players/list/1`}>
                      Players
                    </Link>
                  </li>
                ) : null}
            
                {hasP("basic-user-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/user-management/basic-user") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/user-management/basic-user/list/1`}>
                      Basic Users
                    </Link>
                  </li>
                ) : null}

                <li
                  className={
                    "nav-sub-item" +
                    (loc.pathname.includes("/broadcast") ? " active" : "")
                  }
                >
                  <Link className="nav-sub-link" to="/admin/user-management/broadcast">
                    Broadcast
                  </Link>
                </li>

              </ul>
            </li>
          ) : null}

          {/* Permission Management */}
          {(hasP("permissions-list", true) || hasP("roles-list", true)) ? (
            <li
              className={
                "nav-item " +
                (loc.pathname.includes("/permission-management") ? "show active" : "")
              }
            >
              <a
                className="nav-link with-sub submenu"
                onClick={toggleDropdown}
                href="/"
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-unlock-alt sidemenu-icon"></i>
                <span className="sidemenu-label">Permissions</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              <ul className="nav-sub">
                {hasP("permissions-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/permission-management/permission") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/permission-management/permission/list/1`}>
                      Permissions
                    </Link>
                  </li>
                ) : null}

                {hasP("roles-list") ? (
                  <li
                    className={
                      "nav-sub-item" +
                      (loc.pathname.includes("/permission-management/roles") ? " active" : "")
                    }
                  >
                    <Link className="nav-sub-link" to={`/admin/permission-management/roles/list/1`}>
                      Roles
                    </Link>
                  </li>
                ) : null}
              </ul>
            </li>
          ) : null}

          {/*           
          <li
            className={
              "nav-item" +
              (loc.pathname.includes("/club-management/club") ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/club-management/club/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-users sidemenu-icon"></i>

              <span className="sidemenu-label">{t("Club")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </Link>

          </li> */}

          {/* Club Management */}
          {hasP("club-list", true) ? (
            <li
              className={
                "nav-item" +
                (loc.pathname.includes("/club-management/club") ? " active" : "")
              }
            >
              <Link className="nav-link" to="/admin/club-management/club/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-users sidemenu-icon"></i>
                <span className="sidemenu-label">{t("Club")}</span>
                <i className="angle fe fe-chevron-right"></i>
              </Link>
            </li>
          ) : null}


          {/* Match Management */}
          {hasP("match-list", true) ? (
            <li
              className={
                "nav-item" +
                (loc.pathname.includes("/admin/match-management") ? " active" : "")
              }
            >
              <Link className="nav-link" to="/admin/match-management/match/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-trophy sidemenu-icon"></i>
                <span className="sidemenu-label">{t("Match")}</span>
                <i className="angle fe fe-chevron-right"></i>
              </Link>
            </li>
          ) : null}

       

          {/* Team Management */}
          {hasP("team-list", true) ? (
            <li
              className={
                "nav-item" +
                (loc.pathname.includes("/admin/team-management") ? " active" : "")
              }
            >
              <Link className="nav-link" to="/admin/team-management/team/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-user-friends sidemenu-icon"></i>
                <span className="sidemenu-label">{t("Team")}</span>
                <i className="angle fe fe-chevron-right"></i>
              </Link>
            </li>
          ) : null}

        


          {/* {hasP("report", true) ? (
            <li
              className={
                "nav-item" +
                (loc.pathname.includes("/admin/raw-data-events") ? " active" : "")
              }
            >
              <Link className="nav-link" to="/admin/raw-data-events">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-database sidemenu-icon"></i>
                <span className="sidemenu-label">{t("Raw Data Events")}</span>
                <i className="angle fe fe-chevron-right"></i>
              </Link>
            </li>
          ) : null}  */}

           {/* <li
            className={
              "nav-item" +
              (loc.pathname.includes("/admin/extra-actions") ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/extra-actions/list">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-plus-circle sidemenu-icon"></i>
              <span className="sidemenu-label">Extra Actions</span>
              <i className="angle fe fe-chevron-right"></i>
            </Link>
          </li>   */}
              {/* Early Access */}
          {hasP("early-access-list", true) ? (
            <li
              className={
                "nav-item" +
                (loc.pathname.includes("/admin/early-access") ? " active" : "")
              }
            >
              <Link className="nav-link" to="/admin/early-access/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-rocket sidemenu-icon"></i>
                <span className="sidemenu-label">Early Access</span>
              </Link>
            </li>
          ) : null}
          {/* Contact Us */}
          {hasP("contact-us-list", true) ? (
            <li
              className={
                "nav-item" +
                (loc.pathname.includes("/admin/contact-us") ? " active" : "")
              }
            >
              <Link className="nav-link" to="/admin/contact-us/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-envelope sidemenu-icon"></i>
                <span className="sidemenu-label">Contact Us</span>
              </Link>
            </li>
          ) : null}


          {/* Broadcast Announcements */}
          <li
            className={
              "nav-item" +
              (loc.pathname.includes("/broadcast") ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/broadcast">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-bullhorn sidemenu-icon"></i>
              <span className="sidemenu-label">Broadcast</span>
            </Link>
          </li>

          {/* Transactions */}
          {(hasP("transactions-list", true) || hasP("club-admin-list", true)) ? (
            <li
              className={
                "nav-item" +
                (loc.pathname.includes("/admin/transactions") ? " active" : "")
              }
            >
              <Link className="nav-link" to="/admin/transactions/list/1">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-file-invoice-dollar sidemenu-icon"></i>
                <span className="sidemenu-label">Transactions</span>
              </Link>
            </li>
          ) : null}

          {/* Logs - Shown only when dev=true */}
          {isDev && hasP("club-admin-list", true) ? (
            <li
              className={
                "nav-item" +
                (loc.pathname.includes("/admin/system-logs") ? " active" : "")
              }
            >
              <Link className="nav-link" to="/admin/system-logs">
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-terminal sidemenu-icon"></i>
                <span className="sidemenu-label">Logs</span>
              </Link>
            </li>
          ) : null}
        </ul>
       </div>
   </div>
  );
};

export default SideBar;

